<h1 mat-dialog-title>{{ 'executionEdit.validation.title' | translate }}</h1>
<form [formGroup]="mainForm">

  <div mat-dialog-content class="air-theme" style="min-height: 10vh;">

    @if (showReason()) {
      <div>
        <p> {{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.label' | translate }} </p>
        <mat-form-field class="campoFormulario" style="width: 100%">
          <mat-label>{{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
          <textarea rows="5" matAutosizeMinRows="5" matInput [(ngModel)]="reason" formControlName="reason" required
          [errorStateMatcher]="matcher" style="resize: none;" [ngModelOptions]="{standalone: true}"></textarea>
          <mat-error>
            {{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    @if (!isEmpty(errors)) {
      <div>
        <p> {{ 'executionEdit.validation.hasErrors' | translate }} </p>
        <ul>
          @for (error of errors; track error) {
            <li> {{ error }} </li>
          }
        </ul>
      </div>
    }

    @if (!isEmpty(warns)) {
      <div>
        <p> {{ 'executionEdit.validation.hasWarns' | translate }} </p>
        <ul>
          @for (warn of warns; track warn) {
            <li> {{ warn }} </li>
          }
        </ul>
        @if (isEmpty(errors)) {
          <div>
            <p> {{ 'executionEdit.validation.invalid' | translate }} </p>
            <mat-radio-group [(ngModel)]="forceAccording" formControlName="forceAccording"
              [ngModelOptions]="{standalone: false}">
              <mat-radio-button [value]="true">{{'executionEdit.validation.invalid.yes' | translate}}</mat-radio-button>
              <br />
              <mat-radio-button [value]="false">{{'executionEdit.validation.invalid.no' | translate}}</mat-radio-button>
            </mat-radio-group>
            @if (!forceAccording) {
              <mat-form-field class="campoFormulario" style="width: 100%">
                <mat-label>{{ 'common.reason' | translate }}</mat-label>
                <textarea rows="5" matAutosizeMinRows="5" matInput
                  [(ngModel)]="reasonForce" formControlName="reasonForce" required [errorStateMatcher]="matcher"
                style="resize: none;" [ngModelOptions]="{standalone: true}"></textarea>
              </mat-form-field>
            }
          </div>
        }
      </div>
    }

    @if (isEmpty(errors) && isEmpty(warns)) {
      <div>
        <p> {{ 'executionEdit.validation.valid' | translate }} </p>
      </div>
    }

    @if (canDownloadDocument() && isEmpty(errors)) {
      <div>
        <button mat-raised-button (click)="downloadDocument()" color="accent">
          {{ 'button.download-document-to-sign' | translate }}
        </button>
      </div>
    }

  </div>

  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    @if (canDownloadDocument() && isEmpty(errors)) {
      <button mat-raised-button (click)="uploadDocument.click()"
      color="primary">{{ 'button.upload-signed-document' | translate }}</button>
    }
    <input accept="application/pdf" hidden type="file" (change)="uploadDocumentToExecution($event)" #uploadDocument>

    @if (isEmpty(errors) && !canDownloadDocument()) {
      <button mat-raised-button color="primary" (click)="onOkClick()" [disabled]="!canAccept()" cdkFocusInitial
      >{{ 'button.accept' | translate }}</button>
    }


    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>